export const baseURL = "https://api.wikisocial.net/api";
export const ImgsUrl = "https://api.wikisocial.net";

// Some user/content/category images already come back as full URLs (e.g.
// Google Cloud Storage links); others are relative paths that still need
// ImgsUrl prefixed. Prefixing ImgsUrl onto an already-absolute URL produces
// a broken "ImgsUrl/https://..." address and a blank image, so branch on it.
export const resolveImg = (img) =>
  img?.startsWith("http") ? img : `${ImgsUrl}/${img}`;

// Auth
export const LOGIN = "loginAdmin";
// Add Admin
export const AddAdmin = "addAdmin";

// Posts And Users
export const DeleteContent = "deleteContent";
export const WarningUser = "warningUser";
export const BanUser = "banUser";

export const GetSpotted = "getSpotted";
export const GetReported = "getReportByUser";
export const GetContent = "getContentById";
